module.exports = __webpack_public_path__ + "img/Orders.ca119524.svg";